/* Isolated product prototype: no admin APIs, product writes, or ranking integration. */
(() => {
  const root = document.querySelector('[data-prototype]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-prototype-product]').textContent);
  const money = (value) => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(value / 100);
  const q = (selector) => root.querySelector(selector);
  const all = (selector) => [...root.querySelectorAll(selector)];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Match TOP's brand disclosure timing without changing the native details layout.
  const disclosures = new Map();
  all('details[data-product-anchor]').forEach((details) => {
    const summary = details.querySelector('summary');
    let animation = null;
    let expanded = details.open;
    details.dataset.disclosureExpanded = String(expanded);
    const settle = (open, syncIcon = true) => {
      if (animation) {
        animation.onfinish = null;
        animation.cancel();
        animation = null;
      }
      expanded = open;
      if (syncIcon) details.dataset.disclosureExpanded = String(open);
      details.open = open;
      details.style.removeProperty('overflow');
    };
    disclosures.set(details, settle);
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const start = details.getBoundingClientRect().height;
      const next = animation ? !expanded : !details.open;
      settle(true, false);
      expanded = next;
      if (reducedMotion || !details.animate) {
        settle(next);
        return;
      }
      const fullHeight = details.getBoundingClientRect().height;
      details.open = false;
      const closedHeight = details.getBoundingClientRect().height;
      details.open = true;
      details.style.overflow = 'hidden';
      details.dataset.disclosureExpanded = String(next);
      animation = details.animate([
        { height: `${start}px` },
        { height: `${next ? fullHeight : closedHeight}px` },
      ], { duration: 500, easing: 'cubic-bezier(.22,1,.36,1)' });
      animation.onfinish = () => settle(next);
    });
    // Release measured heights when responsive reflow changes the content size.
    window.addEventListener('resize', () => { if (animation) settle(expanded); });
  });
  all('.be-pdp-prototype__section-nav a').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!matchMedia('(max-width: 749px)').matches) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      if (target.tagName === 'DETAILS') {
        if (disclosures.has(target)) disclosures.get(target)(true);
        else target.open = true;
      }
      const header = document.querySelector('.header-main');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      target.style.setProperty('--product-anchor-header-height', `${headerHeight}px`);
      target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
    });
  });

  // QA states are available only in an unpublished theme and always disable purchases.
  const requestedState = root.dataset.prototypeState || new URL(location.href).searchParams.get('prototype_state');
  const state = data.themeRole !== 'main' && ['sale', 'sold-out', 'no-reviews', 'review-text'].includes(requestedState) ? requestedState : null;
  if (state) {
    q('[data-prototype-notice]').hidden = false;
    q('[data-prototype-notice]').textContent = `表示確認モード：${state}（商品データは未変更・購入操作は無効）`;
  }

  // Some existing multiline fields contain serialized rich-text JSON. Decode as text,
  // never innerHTML, and leave normal text untouched. No metafield value is changed.
  all('[data-prototype-text]').forEach((element) => {
    try {
      const document = JSON.parse(element.textContent);
      if (document.type !== 'root' || !Array.isArray(document.children)) return;
      const text = (node) => node.type === 'text' ? String(node.value || '') : (node.children || []).map(text).join(node.type === 'root' ? '\n' : '');
      element.textContent = text(document);
      element.style.whiteSpace = 'pre-line';
    } catch (_) { /* Plain text is the normal case. */ }
  });

  const gallery = q('[data-gallery]');
  const mobileGallery = matchMedia('(max-width: 749px)');
  const slides = all('[data-image-index]');
  const thumbs = all('[data-thumb]');
  // Keep immutable image sources: slot one is replaced, never moved or inserted.
  const registeredSlides = slides.map((slide, index) => (index === 0
    ? q('[data-original-first-slide]').content.firstElementChild : slide).cloneNode(true));
  const registeredThumbs = thumbs.map((thumb, index) => (index === 0
    ? q('[data-original-first-thumb]').content.firstElementChild : thumb).cloneNode(true));
  const dialog = q('dialog');
  let active = 0;
  let galleryTarget = null;
  let scrollSettleTimer;
  let opener;
  let previousOverflow;
  let closing = false;
  let imageAnimation;
  let drag = null;
  let dragged = false;
  const lightboxImage = q('[data-lightbox-image]');
  const resetZoom = () => { lightboxImage.style.transform = ''; lightboxImage.classList.remove('is-zoomed'); };
  const closeLightbox = () => {
    if (!dialog.open || closing) return;
    closing = true;
    dialog.classList.add('is-closing');
    setTimeout(() => dialog.close(), reducedMotion ? 0 : 220);
  };
  const centerThumbnail = (instant = false) => {
    if (!mobileGallery.matches || !thumbs[active]) return;
    const item = thumbs[active];
    const strip = item.parentElement;
    const left = item.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
    const centered = left + item.offsetWidth / 2 - strip.clientWidth / 2;
    const target = Math.max(0, Math.min(centered, strip.scrollWidth - strip.clientWidth));
    strip.scrollTo({ left: target, behavior: instant || reducedMotion ? 'instant' : 'smooth' });
  };
  const select = (index, scroll = true) => {
    if (!slides.length) return;
    const previous = active;
    active = (index + slides.length) % slides.length;
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
    q('[data-gallery-position]').textContent = `${active + 1} / ${slides.length}`;
    if (scroll || previous !== active) centerThumbnail();
    if (scroll && mobileGallery.matches) {
      galleryTarget = active;
      gallery.scrollTo({ left: active * gallery.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
    }
    if (dialog.open) {
      resetZoom();
      lightboxImage.src = slides[active].dataset.full;
      imageAnimation?.cancel();
      if (previous !== active && !reducedMotion) imageAnimation = lightboxImage.animate([
        { opacity: .35, translate: `${index > previous ? 40 : -40}px 0` },
        { opacity: 1, translate: '0 0' }
      ], { duration: 280, easing: 'cubic-bezier(.4,0,.22,1)' });
      q('[data-lightbox-image]').alt = slides[active].querySelector('img').alt;
      q('[data-lightbox-position]').textContent = `${active + 1} / ${slides.length}`;
    }
  };
  const open = (index, button) => {
    if (dialog.open) return;
    opener = button;
    previousOverflow = document.documentElement.style.overflow;
    closing = false;
    dialog.classList.remove('is-closing');
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    select(index, false);
    q('[data-close]').focus();
  };
  slides.forEach((button) => button.addEventListener('click', () => open(Number(button.dataset.imageIndex), button)));
  all('[data-detail-image]').forEach((button) => button.addEventListener('click', () => open(Number(button.dataset.detailImage), button)));
  thumbs.forEach((button) => button.addEventListener('click', () => select(Number(button.dataset.thumb))));
  let frame;
  const settleGallery = () => {
    clearTimeout(scrollSettleTimer);
    galleryTarget = null;
    if (mobileGallery.matches && !dialog.open) select(Math.round(gallery.scrollLeft / gallery.clientWidth), false);
  };
  gallery.addEventListener('scrollend', settleGallery);
  gallery.addEventListener('pointerdown', () => { galleryTarget = null; }, { passive: true });
  gallery.addEventListener('scroll', () => {
    if (!mobileGallery.matches || dialog.open) return;
    clearTimeout(scrollSettleTimer);
    scrollSettleTimer = setTimeout(settleGallery, 160);
    if (galleryTarget !== null) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => select(Math.round(gallery.scrollLeft / gallery.clientWidth), false));
  }, { passive: true });
  gallery.addEventListener('keydown', (event) => {
    if (!mobileGallery.matches || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
    event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1));
  });
  let galleryWidth = 0;
  new ResizeObserver(() => {
    if (!mobileGallery.matches || dialog.open || galleryWidth === gallery.clientWidth) return;
    galleryWidth = gallery.clientWidth;
    galleryTarget = null;
    gallery.scrollTo({ left: active * gallery.clientWidth, behavior: 'instant' });
    centerThumbnail(true);
  }).observe(gallery);
  q('[data-close]').addEventListener('click', closeLightbox);
  q('[data-prev]').addEventListener('click', () => select(active - 1, false));
  q('[data-next]').addEventListener('click', () => select(active + 1, false));
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeLightbox(); });
  dialog.addEventListener('click', (event) => {
    if (dragged) { dragged = false; return; }
    if (event.target === dialog) closeLightbox();
  });
  lightboxImage.addEventListener('click', () => {
    if (dragged || mobileGallery.matches) return;
    const zoom = !lightboxImage.classList.contains('is-zoomed');
    lightboxImage.classList.toggle('is-zoomed', zoom);
    lightboxImage.style.transform = zoom ? 'scale(1.6)' : '';
  });
  lightboxImage.addEventListener('dragstart', (event) => event.preventDefault());
  dialog.addEventListener('pointerdown', (event) => {
    if (event.target.closest('button') || !event.isPrimary || event.button !== 0) return;
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY };
    dragged = false;
  });
  dialog.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x;
    if (Math.abs(dx) > 8 && !lightboxImage.classList.contains('is-zoomed')) {
      dragged = true;
      dialog.setPointerCapture(event.pointerId);
      lightboxImage.style.transform = `translateX(${dx}px)`;
    }
  });
  const endDrag = (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    drag = null;
    if (dragged) {
      resetZoom();
      if (event.type !== 'pointercancel' && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) select(active + (dx < 0 ? 1 : -1), false);
    }
  };
  dialog.addEventListener('pointerup', endDrag);
  dialog.addEventListener('pointercancel', endDrag);
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1), false); }
  });
  dialog.addEventListener('close', () => {
    imageAnimation?.cancel(); resetZoom(); drag = null; closing = false;
    document.documentElement.style.overflow = previousOverflow;
    opener?.focus({ preventScroll: true });
  });

  const mainForm = q('[data-prototype-cart]');
  const quantity = mainForm.querySelector('[name="quantity"]');
  all('[data-quantity]').forEach((button) => button.addEventListener('click', () => {
    const min = Number(quantity.min) || 1;
    const step = Number(quantity.step) || 1;
    const next = (Number(quantity.value) || min) + Number(button.dataset.quantity) * step;
    quantity.value = Math.max(min, Math.min(quantity.max ? Number(quantity.max) : Infinity, next));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  const renderVariant = () => {
    const variant = data.variants.find((item) => String(item.id) === mainForm.elements.id.value);
    if (!variant) return;
    all('[data-variant-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.variantChoice === String(variant.id))));
    const price = state === 'sale' ? Math.floor(variant.price * .9) : variant.price;
    const compare = state === 'sale' ? variant.price : variant.compare_at_price;
    const sale = compare > price;
    q('[data-current-price]').textContent = money(price);
    q('[data-compare-price]').textContent = money(compare || 0);
    q('[data-compare-price]').hidden = !sale;
    q('[data-sale-badge]').hidden = !sale;
    q('[data-price]').classList.toggle('is-sale', sale);
    if (q('[data-points]')) q('[data-points]').textContent = Math.floor(price / 10000);
    const unavailable = !variant.available || state === 'sold-out';
    q('[data-main-submit]').disabled = unavailable || !!state || mainForm.dataset.cartPending === 'true';
    q('[data-main-submit]').textContent = unavailable ? 'SOLD OUT' : 'カートに入れる';
    quantity.min = variant.quantity_rule?.min || 1;
    quantity.step = variant.quantity_rule?.increment || 1;
    quantity.max = variant.quantity_rule?.max || '';
    quantity.value = quantity.min;
    const measurement = data.measurements[variant.id];
    // Only a unit-price measurement is a reliable variant capacity; shipping weight is not.
    const capacity = (measurement?.quantity_value ? `${measurement.quantity_value} ${measurement.quantity_unit}` : data.capacity).replace(/(\d)\.0+(?!\d)/g, '$1');
    all('[data-capacity]').forEach((element) => { element.textContent = capacity; element.hidden = !capacity; });
    const wishlist = q('.be-pdp-prototype__wishlist');
    wishlist.dataset.wlhVariantid = variant.id;
    wishlist.dataset.wlhPrice = variant.price / 100;
    const mediaId = data.variantMedia?.[variant.id] || variant.featured_media?.id;
    const selectedSlide = registeredSlides.find((slide) => slide.dataset.mediaId === String(mediaId))
      || registeredSlides.find((slide) => variant.featured_image?.src && new URL(slide.dataset.full, location.href).pathname === new URL(variant.featured_image.src, location.href).pathname)
      || registeredSlides[0];
    if (selectedSlide) {
      slides[0].dataset.mediaId = selectedSlide.dataset.mediaId;
      slides[0].dataset.full = selectedSlide.dataset.full;
      const image = selectedSlide.querySelector('img').cloneNode(true);
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
      slides[0].querySelector('img').replaceWith(image);
      if (thumbs[0]) {
        const sourceThumb = registeredThumbs[registeredSlides.indexOf(selectedSlide)];
        thumbs[0].dataset.mediaId = selectedSlide.dataset.mediaId;
        thumbs[0].querySelector('img').replaceWith(sourceThumb.querySelector('img').cloneNode(true));
      }
      clearTimeout(scrollSettleTimer);
      cancelAnimationFrame(frame);
      galleryTarget = 0;
      gallery.scrollTo({ left: 0, behavior: 'instant' });
      select(0, false);
      centerThumbnail(true);
    }
  };
  q('[data-main-variant]')?.addEventListener('change', () => {
    renderVariant();
    if (location.protocol !== 'about:') {
      const url = new URL(location.href); url.searchParams.set('variant', mainForm.elements.id.value); history.replaceState({ ...history.state }, '', url);
    }
  });
  all('[data-variant-choice]').forEach((button) => button.addEventListener('click', () => {
    const select = q('[data-main-variant]');
    if (select.value === button.dataset.variantChoice) return;
    select.value = button.dataset.variantChoice;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  renderVariant();
  // Share the main form (including quantity and validation); never create a second cart request path.
  const sticky = q('[data-sticky-cart]');
  if (sticky) {
    const mainButton = q('[data-main-submit]');
    const stickyButton = q('[data-sticky-submit]');
    const stickyVariant = q('[data-sticky-variant]');
    const status = mainForm.querySelector('[data-cart-status]');
    const syncSticky = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent;
      const stickyPrice = q('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = q('[data-current-price]').textContent;
      if (stickyVariant) stickyVariant.value = mainForm.elements.id.value;
      const image = q('[data-sticky-image]');
      const mainImage = slides[0]?.querySelector('img');
      if (image && mainImage) image.src = mainImage.currentSrc || mainImage.src;
      q('[data-sticky-status]').replaceChildren(...[...status.childNodes].map(node => node.cloneNode(true)));
    };
    stickyVariant?.addEventListener('change', () => {
      const select = q('[data-main-variant]');
      select.value = stickyVariant.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    mainForm.addEventListener('change', syncSticky);
    stickyButton.addEventListener('click', () => {
      if (!mainButton.disabled) mainForm.requestSubmit(mainButton);
    });
    const observer = new MutationObserver(syncSticky);
    observer.observe(mainButton, { attributes: true, childList: true, subtree: true });
    observer.observe(status, { childList: true, subtree: true, characterData: true });
    syncSticky();
    const threshold = q('.be-pdp-prototype__description-section') || q('.be-pdp-prototype__details');
    let stickyFrame = 0;
    const updateSticky = () => {
      stickyFrame = 0;
      const atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
      const show = threshold.getBoundingClientRect().bottom <= window.innerHeight && !atBottom;
      if (!show && sticky.contains(document.activeElement)) mainButton.focus({ preventScroll: true });
      sticky.hidden = false;
      sticky.classList.toggle('is-visible', show);
      sticky.inert = !show;
      sticky.setAttribute('aria-hidden', String(!show));
    };
    const scheduleSticky = () => {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
    };
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky);
    new ResizeObserver(scheduleSticky).observe(document.body);
    updateSticky();
  }
  // Wishlist Hero initialization is shared with product cards via .be-wishlist.

  if (state === 'no-reviews' || data.ratingCount === 0) {
    q('[data-rating-summary]').hidden = true;
    q('[data-empty-review]').hidden = false;
    // Keep the live app on real zero-review products (including its write-review button).
    if (state === 'no-reviews') {
      q('[data-review-widget]').hidden = true;
      q('[data-qa-review-button]').hidden = false;
    }
  }

  // Review identity, not list order: sorting/new reviews never reassign existing avatars.
  const avatarAssets = JSON.parse(q('[data-review-avatar-assets]')?.textContent || '[]');
  const avatarIndex = (key) => {
    let hash = 2166136261;
    for (const char of key) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
    return (hash >>> 0) % avatarAssets.length;
  };
  const syncReviewAvatar = (review, head, fixtureKey) => {
    if (!avatarAssets.length) return;
    const reviewId = fixtureKey || review.getAttribute('review-id') || review.dataset.reviewId;
    const key = reviewId || [data.id, head.querySelector('.author-name')?.textContent.trim(),
      review.querySelector('time')?.getAttribute('datetime'), review.querySelector('.reviews-text')?.textContent.trim()].join('|');
    const fallback = avatarAssets[avatarIndex(key)];
    // Adapter for a genuine profile photo supplied by the review provider.
    // Never use review attachment/product images as author profile photos.
    const profile = head.querySelector('img[data-reviewer-avatar], .user-avatar img, img.user-avatar, .author-avatar img, img.author-avatar');
    const profileUrl = review.dataset.reviewerAvatarUrl || profile?.getAttribute('src');
    const source = profileUrl && /^(https?:)?\/\//.test(profileUrl) ? profileUrl : fallback;
    let image = head.querySelector('img[data-prototype-review-avatar]');
    if (!image) {
      image = document.createElement('img');
      image.dataset.prototypeReviewAvatar = '';
      image.className = 'be-pdp-prototype__review-avatar';
      image.width = 40; image.height = 40; image.alt = ''; image.loading = 'lazy';
      image.addEventListener('error', () => {
        if (image.getAttribute('src') !== image.dataset.fallback) image.src = image.dataset.fallback;
      });
      head.prepend(image);
    }
    if (profile && !profile.hidden) profile.hidden = true;
    if (image.dataset.source !== source) {
      image.dataset.source = source;
      image.dataset.fallback = fallback;
      image.src = source;
    }
  };

  if (state === 'review-text') {
    q('[data-review-widget]').hidden = true;
    q('[data-empty-review]').hidden = true;
    const fixture = document.createElement('div');
    fixture.dataset.reviewFixture = '';
    const note = document.createElement('p');
    note.textContent = '本文表示テスト：以下は架空のレビューです。実際の投稿・評価には反映されません。';
    fixture.append(note);
    const samples = [
      ['テスト投稿者 A（架空）', 5, '短い本文の表示確認', 'これは表示確認用のサンプルです。短いレビュー本文の行間と余白を確認しています。'],
      ['テスト投稿者 B（架空）', 4, '長い本文・改行の表示確認', 'これは実際の口コミではなく、レイアウト確認用の文章です。文章が複数行に折り返したときに、丸い人物アイコン・投稿者名・星・本文の位置が自然につながるかを確認しています。\n\n二段落目のサンプルです。スマートフォンでも本文が画面幅に収まり、文字が重ならず読みやすいことを確認するため、少し長めの文章を表示しています。']
    ];
    samples.forEach(([name, rating, title, body]) => {
      const article = document.createElement('article');
      const head = document.createElement('div');
      head.className = 'list-review-head';
      syncReviewAvatar(article, head, `fixture:${data.id}:${name}`);
      const author = document.createElement('div');
      author.textContent = name;
      const stars = document.createElement('div');
      stars.className = 'be-pdp-prototype__fixture-stars';
      stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      stars.setAttribute('aria-label', `表示テスト：5点満点中${rating}点`);
      head.append(author, stars);
      const heading = document.createElement('h3');
      heading.textContent = title;
      const text = document.createElement('p');
      text.textContent = body;
      article.append(head, heading, text);
      fixture.append(article);
    });
    q('#prototype-reviews').append(fixture);
  }

  // Reuse Trustoo's server-backed sorting; never sort only the currently loaded page.
  const reviewWidget = q('[data-review-widget]');
  if (reviewWidget && state !== 'no-reviews' && state !== 'review-text') {
    const syncReviewControls = () => {
      reviewWidget.querySelectorAll('#reviews-body .list-review').forEach((review) => {
        const head = review.querySelector('.list-review-head');
        if (!head) return;
        syncReviewAvatar(review, head);
        const stars = review.querySelector('.list-review-body > .vstar-star');
        if (stars) head.append(stars);
      });
      const controls = reviewWidget.querySelector('.tt-head-right');
      const nativeSort = controls?.querySelector('.head-sort');
      if (!nativeSort) return;
      let select = controls.querySelector('[data-prototype-review-sort]');
      if (!select) {
        select = document.createElement('select');
        select.dataset.prototypeReviewSort = '';
        select.setAttribute('aria-label', 'レビューの並び順');
        const labels = {
          'commented-at-descending': '最新順',
          'rating-descending': '評価の高い順',
          'rating-ascending': '評価の低い順',
          'image-descending': '写真付き優先',
          'comprehensive-descending': 'おすすめ順'
        };
        for (const [value, label] of Object.entries(labels)) {
          if (!nativeSort.querySelector(`[sort-value="${value}"]`)) continue;
          select.add(new Option(label, value));
        }
        select.addEventListener('change', () => {
          const item = controls.querySelector(`[sort-value="${select.value}"]`);
          item?.click();
        });
        controls.append(select);
        nativeSort.classList.add('be-pdp-native-sort');
      }
      const active = nativeSort.querySelector('.sort-item.active');
      if (active) select.value = active.getAttribute('sort-value');
    };
    const reviewObserver = new MutationObserver(syncReviewControls);
    reviewObserver.observe(reviewWidget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src', 'review-id', 'data-review-id', 'data-reviewer-avatar-url'] });
    syncReviewControls();
  }

  root.addEventListener('change', (event) => {
    if (!event.target.matches('[data-addon-variant]')) return;
    const option = event.target.selectedOptions[0];
    const article = event.target.closest('article');
    const formatPrice = (cents) => article.dataset.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
      const formats = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'],
        amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_period_and_space_separator: [2, ' ', '.']
      };
      const [precision, thousands, decimal] = formats[token] || formats.amount;
      const [whole, fraction] = (Number(cents) / 100).toFixed(precision).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    });
    const price = Number(option.dataset.price);
    const comparePrice = Number(option.dataset.compare);
    article.querySelector('.price-value').textContent = formatPrice(price);
    const compare = article.querySelector('[data-addon-compare]');
    compare.textContent = formatPrice(comparePrice);
    compare.hidden = comparePrice <= price;
    const button = article.querySelector('[type="submit"]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'SOLD OUT' : 'カートに入れる';
  });
  root.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-prototype-cart]');
    if (!form) return;
    event.preventDefault();
    if (state || !form.reportValidity()) return;
    const button = form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-cart-status]');
    if (button.disabled || form.dataset.cartPending === 'true') return;
    form.dataset.cartPending = 'true';
    button.disabled = true;
    message.textContent = '追加しています…';
    try {
      const response = await fetch(`${data.root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'カートへ追加できませんでした。');
      if (form.closest('.be-pdp-addon')) {
        const statusText = document.createElement('span');
        statusText.textContent = 'カートに追加しました。';
        message.replaceChildren(statusText);
      } else {
        message.textContent = 'カートに追加しました。';
      }
      const link = document.createElement('a'); link.href = `${data.root}cart`; link.append(' ');
      const linkText = document.createElement('span'); linkText.className = 'be-pdp-cart-link-text'; linkText.textContent = 'カートを見る';
      link.append(linkText); message.append(link);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-prototype', productVariantId: result.variant_id });
      }
    } catch (error) { message.textContent = error.message || '通信エラーです。もう一度お試しください。'; }
    finally {
      delete form.dataset.cartPending;
      const selected = data.variants.find(item => String(item.id) === mainForm.elements.id.value);
      button.disabled = form === mainForm ? !selected?.available || !!state : false;
    }
  });

  const sectionUrl = (path, section) => {
    const url = new URL(path, document.baseURI);
    url.searchParams.set('section_id', section);
    if (data.themeRole !== 'main') url.searchParams.set('preview_theme_id', data.themeId);
    return url;
  };
  const getDocument = async (url) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('商品の取得に失敗しました。');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };
  const intersect = (left, right) => Array.isArray(left) && Array.isArray(right) && left.some((value) => right.includes(value));
  const score = (item) => (data.brand && item.brand === data.brand ? 16 : 0) + (data.type && item.type === data.type ? 8 : 0) + (intersect(data.categories, item.categories) ? 4 : 0) + (intersect(data.concerns, item.concerns) ? 2 : 0);
  const recommend = async () => {
    try {
      const products = new Map();
      let next = data.root;
      const visited = new Set();
      while (next) {
        const url = sectionUrl(next, 'be-pdp-prototype-catalog');
        if (visited.has(url.href)) throw new Error('関連商品のページ取得に失敗しました。');
        visited.add(url.href);
        const document = await getDocument(url);
        const payload = JSON.parse(document.querySelector('[data-prototype-catalog]').textContent);
        payload.products.forEach((item) => { if (item.available && item.id !== data.id) products.set(item.id, item); });
        next = payload.next;
      }
      const ranked = [...products.values()].sort((a, b) => score(b) - score(a) || a.handle.localeCompare(b.handle));
      // Select complements independently; leave the existing related ranking unchanged.
      const selected = [], attempted = new Set();
      while (selected.length < 3) {
        const candidates = ranked.filter(item => !attempted.has(item.id));
        const item = window.BePdpSetSelection.rank(data, candidates, selected)[0];
        if (!item) break;
        attempted.add(item.id);
        try {
          const doc = await getDocument(sectionUrl(`${data.root}products/${encodeURIComponent(item.handle)}`, 'be-pdp-prototype-card'));
          const template = doc.querySelector('[data-prototype-addon]');
          if (!template?.content.firstElementChild || !template.content.querySelector('[type="submit"]:not([disabled])')) continue;
          const node = template.content.cloneNode(true);
          if (state) node.querySelectorAll('[type="submit"]').forEach(button => { button.disabled = true; });
          q('[data-addons]').append(node);
          selected.push(item);
        } catch (_) { /* Deleted or newly unavailable products are replaced by the next complement. */ }
      }
      if (!selected.length) q('[data-addons]').closest('.be-pdp-prototype__addons').hidden = true;
      const related = ranked.filter(item => !selected.some(addon => addon.id === item.id));
      let relatedCount = 0;
      for (let start = 0; start < related.length && relatedCount < 6; start += 4) {
        const batch = await Promise.all(related.slice(start, start + 4).map(async (item) => {
          try { return await getDocument(sectionUrl(`${data.root}products/${encodeURIComponent(item.handle)}`, 'be-pdp-prototype-card')); } catch (_) { return null; }
        }));
        for (const document of batch) {
          if (!document || relatedCount >= 6) continue;
          const template = document.querySelector('[data-prototype-related-card]');
          if (!template?.content.firstElementChild) continue;
          const node = template.content.cloneNode(true);
          if (state) node.querySelectorAll('[type="submit"]').forEach(button => { button.disabled = true; });
          q('[data-related]').append(node);
          relatedCount++;
        }
      }
      const count = selected.length + relatedCount;
      q('[data-recommend-status]').textContent = count < 9 ? '現在表示できる関連商品を掲載しています。' : '';
    } catch (_) { q('[data-recommend-status]').textContent = '関連商品を読み込めませんでした。ページを再読み込みしてください。'; }
    finally { all('[aria-busy]').forEach((element) => element.setAttribute('aria-busy', 'false')); }
  };
  // Avoid blocking the primary image and purchasing UI.
  if ('requestIdleCallback' in window) requestIdleCallback(recommend, { timeout: 1500 }); else setTimeout(recommend, 100);
})();
